import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.70013 4.4428L12 1.92285L18.2999 4.4428L17.5571 6.29975L17 6.07692V7.99988H23V21.9999H13V15H11V21.9999H1V7.99988H7V6.07692L6.44291 6.29975L5.70013 4.4428ZM3 19.9999H7V9.99988H3V19.9999ZM17 9.99988V19.9999H21V9.99988H17ZM13.0039 6.99805H11V9.00195H13.0039V6.99805Z"}}]};

const City14Filled = Vue.extend<IconProps>({
  name: 'City14FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'city-14-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default City14Filled;
